<template>
  <wv-steak-house-default-section :section="section" :menu="menu"
                                  class="menu--section-dessert"
                                  :class="{'menu--section-after_dinner_drinks': isAfterDinnerDrinksSection}"></wv-steak-house-default-section>
</template>

<script lang="ts">
/**
 * Special component for WV Steak House dessert section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - Copy <WvSteakHouseDessertSection> component from <Bimini_dessert>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <WvSteakHouseDessertSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  components: {
    WvSteakHouseDefaultSection,
  },
  name: "WvSteakHouseDessertSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    isAfterDinnerDrinksSection() {
      return /after dinner/i.test(this.section.ms_title) && /drinks/i.test(this.section.ms_title);
    }
  },
})
</script>

<style scoped>
.menu--section-dessert,
.visual_menu--container-landscape .menu--section-dessert {
  padding-left: 8em;
  padding-right: 8em;
}

.menu--section-dessert:deep(.menu--item_description) {
  margin-left: 0;
}

.menu--section-dessert.menu--section-after_dinner_drinks:deep(.menu--item_subgroup) {
  grid-gap: 0.25em;
}

.menu--section-dessert.menu--section-after_dinner_drinks:deep(.menu--section_title) {
  margin-bottom: 1.5em;
}

.menu--section-dessert.menu--section-after_dinner_drinks:deep(.menu--section_subgroup_title) {
  margin-top: 1em;
  margin-bottom: 0.3em;
}
</style>